export type EntryLinkItemContent = {
  readonly key: string;
  readonly entryId: string;
  readonly label: string;
  readonly href: string | undefined;
  readonly status: 'ready' | 'broken';
};

/**
 * Immutable Entry Link presentation in stored reference order.
 */
export type EntryLinkReadContent = {
  readonly kind: 'entry-link';
  readonly loadingWidth?: number;
  readonly links: readonly EntryLinkItemContent[];
};

export const EMPTY_ENTRY_LINK_CONTENT: EntryLinkReadContent = Object.freeze({
  kind: 'entry-link',
  links: Object.freeze([])
});
